import Tooltip from '@material-ui/core/Tooltip';
import React, { useState } from 'react';

import { changeDateFormat, convertNumberToUSFormat } from '@utils/Util';

const INFO_ICON = `${process.env.PUBLIC_URL}/icons/info.svg`;

const STATUS_LABEL = {
	PENDING: 'Pending',
	APPROVED: 'Approved',
	REJECTED: 'Rejected'
};

/***
 * Shows the Head of Supply Chain approval state of the factory price of a single style. Only the status sits in
 * the card; who raised the request and when is kept behind the info icon so the row stays compact.
 * The approve and reject actions live in the margin tab, so this is read only.
 */
const FactoryPriceApprovalInfo = ({ quote }) => {
	const [isDetailOpen, setIsDetailOpen] = useState(false);

	const status = quote?.factoryPriceApprovalStatus;
	if (!status) return null;

	const formatPrice = (price) => (price || price === 0 ? convertNumberToUSFormat(price) : '-');

	const formatDate = (date) => (date ? changeDateFormat(date, 'YYYY-MM-DD', 'DD MMM, YY') : '');

	const requestedAt = formatDate(quote?.factoryPriceApprovalRequestedAt);
	const respondedAt = formatDate(quote?.factoryPriceApprovalRespondedAt);

	const approvalDetails = (
		<div className="factory-price-approval-details">
			<p className="mb-1 weight-600">Factory price approval request</p>
			<p className="mb-1">
				From: {quote?.factoryPriceApprovalRequestedBy || '-'}
				{requestedAt && ` · ${requestedAt}`}
			</p>
			{/* The first request has no meaningful previous price, so the change is shown only on a retry. */}
			{quote?.factoryPriceApprovalIsRetry && (
				<p className="mb-1">
					{formatPrice(quote?.factoryPriceApprovalOldPrice)} {'→'}{' '}
					{formatPrice(quote?.factoryPriceApprovalNewPrice)}
				</p>
			)}
			{status !== 'PENDING' && respondedAt && <p className="mb-0">Responded: {respondedAt}</p>}
		</div>
	);

	return (
		<div className="factory-price-approval-status d-flex align-items-center justify-content-end">
			<span className={`approval-status-pill ${status.toLowerCase()}`}>
				{STATUS_LABEL[status] || status}
			</span>
			<Tooltip
				title={approvalDetails}
				placement="top"
				arrow
				interactive
				open={isDetailOpen}
				onOpen={() => setIsDetailOpen(true)}
				onClose={() => setIsDetailOpen(false)}
			>
				{/* The details open on hover, and the click keeps them open for a touch device or a slow read. */}
				<img
					className="approval-info-icon cursor-pointer ml-1"
					src={INFO_ICON}
					alt="Factory price approval details"
					onClick={() => setIsDetailOpen((previous) => !previous)}
				/>
			</Tooltip>
		</div>
	);
};

export default FactoryPriceApprovalInfo;
